import { createContext, useContext, useReducer } from 'react';
import React from 'react';

// Define the initial state and actions for the context
const CompanySubscriberContext = createContext();

export const useCompanySubscriberContext = () => {
    return useContext(CompanySubscriberContext);
};

const initialState = {
    companySubscribers: [],
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'ADD_COMPANY_SUBSCRIBER':
            return {
                ...state,
                companySubscribers: [...state.companySubscribers, action.payload],
            };
        case 'REMOVE_COMPANY_SUBSCRIBER':
            return {
                ...state,
                companySubscribers: state.companySubscribers.filter(
                    (subscriber) => subscriber.id !== action.payload
                ),
            };
        case 'SET_SUBSCRIBERS':
            return {
                ...state,
                companySubscribers: action.payload, // Set the subscribers array with the payload
            };
        default:
            return state;
    }
};

export const CompanySubscriberProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    console.log('CompanySubscriberProvider rendering with state:', state);


    return (
        <CompanySubscriberContext.Provider value={{ state, dispatch }}>
            {children}
        </CompanySubscriberContext.Provider>
    );
};
